import clsx from 'clsx';
import { ReactNode, useState } from 'react';

import styles from './ThemeLogoIcon.module.scss';

export const ThemeLogoIcon = ({
  name,
  logo_url,
  isCondensed = false,
  fallbackIcon,
  size,
  isDisabled,
}: {
  name: string;
  logo_url?: string;
  isCondensed?: boolean;
  fallbackIcon?: ReactNode;
  size?: number;
  isDisabled?: boolean;
}) => {
  const [imageError, setImageError] = useState(false);

  const dimensionStyle =
    size !== undefined ? { width: size, height: size } : undefined;

  return logo_url && !imageError ? (
    <img
      alt=""
      data-theme-logo-icon
      className={clsx(styles.logoImg, {
        [styles.condensed]: size === undefined && isCondensed,
        [styles.disabled]: isDisabled,
      })}
      src={logo_url}
      style={dimensionStyle}
      onError={() => setImageError(true)}
    />
  ) : (
    <>
      {fallbackIcon ?? (
        <div
          className={clsx(styles.logoFallback, {
            [styles.condensed]: isCondensed,
            [styles.disabled]: isDisabled,
          })}
          data-theme-logo-icon
          style={dimensionStyle}
        >
          {name.charAt(0)}
        </div>
      )}
    </>
  );
};
